module.exports = __webpack_public_path__ + "static/media/caseiqgif.8342e9fd.gif";